// Warm ivory + honey-gold outline — reserved for the current visitor.
// Stationery, not app icon: the fill is just barely warmer than the page
// (surface = #FBF9F6) so it recedes, and the 2px honey border carries the
// identity. Charcoal initial keeps ~10:1 contrast on the ivory fill.
export const ME_AVATAR = {
  bg: "#F6F1E4",
  border: "#CDA64A",
  fg: "#2B312A",
};

// Neutral cream — the default look for everyone else. Cool, quiet,
// intentionally recedes so the visitor's honey avatar stands out gently.
export const OTHER_AVATAR = {
  bg: "#EFEAE0",
  border: "#DCD3BF",
  fg: "#5A5648",
};

export function initials(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/).slice(0, 2);
  return parts.map((p) => p[0]?.toUpperCase() || "").join("") || name[0].toUpperCase();
}
